module.exports = __webpack_public_path__ + "static/gelwe-244eb9393b7039d3e4f73f8485f629f4.png";